export const de = {
  paper: {
    pagination: "Seite {current} von {count}",
    printedOn: "Gedruckt am {date} um {time}",
  },
};
